"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _dxcScrollMenu = _interopRequireDefault(require("dxc-scroll-menu"));

var _ImageMenu = _interopRequireDefault(require("../../assets/ImageMenu.css"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _panoMarquee = _interopRequireDefault(require("pano-marquee"));

var _dxcFlex = _interopRequireDefault(require("dxc-flex"));

var _onResize = _interopRequireDefault(require("../onResize"));

var _seend = _interopRequireDefault(require("../../assets/seend.png"));

var _utils = require("../utils");

var _payIcon = _interopRequireDefault(require("../../assets/payIcon.png"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_ImageMenu["default"]);

var MenuContent = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(MenuContent, _React$PureComponent);

  function MenuContent() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "onClick", function (id, e) {
      // e.preventDefault();
      // e.stopPropagation();
      var onClick = _this.props.onClick;
      onClick && onClick(id);
    });

    _defineProperty(_assertThisInitialized(_this), "renderItem", function (_ref) {
      var id = _ref.id,
          name = _ref.name,
          thumbUrl = _ref.thumbUrl;
      var _this$props = _this.props,
          seenScenes = _this$props.seenScenes,
          disableTip = _this$props.disableTip,
          payScenes = _this$props.payScenes;
      var isSeend = seenScenes.indexOf(id) >= 0;
      var isPay = payScenes.indexOf(id) >= 0;
      var _this$props2 = _this.props,
          selected = _this$props2.selected,
          size = _this$props2.size,
          THUMB_DOMAIN = _this$props2.THUMB_DOMAIN,
          _this$props2$urlSplic = _this$props2.urlSplicing,
          urlSplicing = _this$props2$urlSplic === void 0 ? _utils._urlSplicing : _this$props2$urlSplic;
      var url = urlSplicing(thumbUrl, THUMB_DOMAIN, 200);
      var backgroundImage = "url(\"" + url + "\")";
      var param = {};

      if (!disableTip) {
        param["data-tip"] = name;
      }

      return /*#__PURE__*/_react["default"].createElement("div", _extends({}, param, {
        onClick: _this.onClick.bind(_assertThisInitialized(_this), id),
        className: cx("ImageMenuItem", {
          selected: selected === id
        })
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: cx("ImageMenuContent"),
        style: {
          backgroundImage: backgroundImage
        }
      }, isPay ? /*#__PURE__*/_react["default"].createElement("img", {
        alt: "",
        src: _payIcon["default"],
        className: cx("ImageMenuItemPayIcon")
      }) : null, isSeend ? /*#__PURE__*/_react["default"].createElement("img", {
        alt: "",
        src: _seend["default"],
        className: cx("ImageMenuItemSeend")
      }) : null, /*#__PURE__*/_react["default"].createElement(_dxcFlex["default"], {
        vertical: "center",
        horizontal: "center",
        className: cx("ImageMenuText")
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          margin: "0 5px"
        }
      }, /*#__PURE__*/_react["default"].createElement(_panoMarquee["default"], {
        maxWidth: size.MarqueeMaxWidth,
        disable: selected !== id,
        fontSize: size.MarqueeFontSize,
        text: name
      })))));
    });

    _defineProperty(_assertThisInitialized(_this), "renderArrowRight", function (disable, onClick) {
      if (disable) return null;
      return /*#__PURE__*/_react["default"].createElement(_dxcFlex["default"], {
        onClick: onClick,
        horizontal: "center",
        vertical: "center",
        className: cx("MenuArrowRight")
      }, /*#__PURE__*/_react["default"].createElement("div", null));
    });

    _defineProperty(_assertThisInitialized(_this), "renderArrowLeft", function (disable, onClick) {
      if (disable) return null;
      return /*#__PURE__*/_react["default"].createElement(_dxcFlex["default"], {
        onClick: onClick,
        horizontal: "center",
        vertical: "center",
        className: cx("MenuArrowLeft")
      }, /*#__PURE__*/_react["default"].createElement("div", null));
    });

    return _this;
  }

  var _proto = MenuContent.prototype;

  _proto.render = function render() {
    var _this$props3 = this.props,
        selected = _this$props3.selected,
        data = _this$props3.data,
        selectedChangeResize = _this$props3.selectedChangeResize;
    return /*#__PURE__*/_react["default"].createElement(_dxcScrollMenu["default"], {
      selectedChangeResize: selectedChangeResize,
      arrowRight: this.renderArrowRight,
      arrowLeft: this.renderArrowLeft,
      data: data,
      selected: selected,
      renderItem: this.renderItem
    });
  };

  return MenuContent;
}(_react["default"].PureComponent);

var _default = (0, _onResize["default"])({
  "default": {
    MarqueeMaxWidth: 80,
    MarqueeFontSize: 12
  },
  1024: {
    MarqueeMaxWidth: 60,
    MarqueeFontSize: 9
  }
})(MenuContent);

exports["default"] = _default;
module.exports = exports.default;